import { TextField, TextFieldProps } from '@components/text-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormTextFieldProps<T = unknown> = FormFieldProps<TextFieldProps, T>;

export function FormTextField<T>(props: FormTextFieldProps<T>) {
  const formFieldProps = useFormField(props);
  const { hideRequiredIndicator, ...rest } = props;

  return <TextField {...rest} {...formFieldProps} />;
}
